// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"dc9e1da6","112":"20d0ba77","378":"26d243ad","412":"f5061346","457":"a08a5e2a","459":"c96f60f4","926":"9e5fcab5"}[chunkId] + ".js";
};